module.exports = __webpack_public_path__ + "img/9@2x.a370e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/9@2x.png
// module id = 55xf
// module chunks = 0